import { Suspense } from 'react';

// project imports
import Loader from './Loader';
import { lazyWithRecovery } from '../utils/lazyWithRecovery';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (importFn) => {
  const Component = lazyWithRecovery(importFn);
  return (props) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
